import { Box, Typography } from '@mui/material';
import { TOKEN_SFL } from '../../../lib/name-space';
import { tokenSupplyStatusList, TokenSupplyStatusType, triTokenSupplyStatusList } from './list';

export function TokenSupplyStatusDataName({ type }: { type: string }) {
  const dataList: TokenSupplyStatusType[] = type === TOKEN_SFL ? tokenSupplyStatusList : triTokenSupplyStatusList;
  return (
    <>
      {dataList.map((data: TokenSupplyStatusType) => (
        <Typography
          key={data.label}
          sx={{
            fontWeight: '600',
            fontSize: '16px',
            lineHeight: '19.09px',
            letterSpacing: 0,
            color: '#333333',
          }}
        >
          {data.label}
        </Typography>
      ))}
    </>
  );
}
export function TokenSupplyStatusDataGraph({ type }: { type: string }) {
  const dataList: TokenSupplyStatusType[] = type === TOKEN_SFL ? tokenSupplyStatusList : triTokenSupplyStatusList;
  return (
    <>
      {dataList.map((data: TokenSupplyStatusType) => (
        <Box
          key={data.label}
          sx={{
            width: data.chartData.width,
            height: '20px',
            background: data.chartData.color,
          }}
        >
          <Typography
            sx={{
              fontSize: '12px',
              color: '#333333',
              textAlign: 'right',
              mr: '12.1px',
              ml: '3px',
            }}
          >
            {data.chartData.percent}
          </Typography>
        </Box>
      ))}
    </>
  );
}
export function TokenSupplyStatusDataAmount({ type }: { type: string }) {
  const dataList: TokenSupplyStatusType[] = type === TOKEN_SFL ? tokenSupplyStatusList : triTokenSupplyStatusList;
  return (
    <>
      {dataList.map((data: TokenSupplyStatusType) => (
        <Typography
          key={data.label}
          sx={{
            fontWeight: '500',
            fontSize: '16px',
            lineHeight: '19.09px',
            letterSpacing: 0,
            color: '#333333',
          }}
        >
          {data.shuffle} {type}
        </Typography>
      ))}
    </>
  );
}
